import React from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';

interface Experience {
  title: string;
  company: string;
  location: string;
  description: string;
  date: string;
  current?: boolean;
}

const experiences: Experience[] = [
  {
    title: 'مهندس برمجيات',
    company: 'HudHud Maps',
    location: 'الرياض',
    description: 'العمل على منصات الخرائط ونقاط الاهتمام، والمساهمة في الخدمات الخلفية وتدفُّقات البيانات وموثوقية الأنظمة الإنتاجية.',
    date: 'أكتوبر ٢٠٢٤ — الآن',
    current: true,
  },
  {
    title: 'قائد فريق تقني',
    company: 'Innovative Front IT',
    location: 'الرياض',
    description: 'قيادة فريق تقني لتسليم حلول خلفية وAPIs عالية الجودة. إدارة CI/CD، مراجعة الكود، وتنسيق مهام التطوير.',
    date: '٢٠٢٣ — ٢٠٢٤',
  },
  {
    title: 'مطوِّر برمجيات',
    company: 'MOCATION',
    location: 'الرياض',
    description: 'قيادة مبادرات التحوُّل الرقمي وأتمتة العمليات وبناء APIs بـ Google Workspace وZapier.',
    date: '٢٠٢٢ — ٢٠٢٣',
  },
  {
    title: 'متدرِّب مهندس برمجيات',
    company: 'SAFCSP',
    location: 'الرياض',
    description: 'اكتساب خبرة عملية في تطوير الخلفية باستخدام Docker وFastAPI وPostgreSQL في بيئة إنتاجية حقيقية.',
    date: '٢٠٢٢',
  },
];

interface Education {
  degree: string;
  institution: string;
  date: string;
  current?: boolean;
}

const education: Education[] = [
  {
    degree: 'ماجستير علم البيانات',
    institution: 'جامعة الأمير سطام بن عبدالعزيز',
    date: '٢٠٢٥ — الآن',
    current: true,
  },
  {
    degree: 'بكالوريوس علوم الحاسب',
    institution: 'جامعة الملك خالد',
    date: '٢٠٢٠ — ٢٠٢٤',
  },
];

const skills = [
  'تطوير الخوادم الخلفية',
  'تطوير الواجهات الأمامية',
  'REST APIs',
  'قواعد البيانات',
  'أتمتة العمليات',
  'النشر السحابي',
  'إدارة الفرق التقنية',
  'تحليل البيانات',
];

const tools = [
  'Python', 'FastAPI', 'Express.js', 'Node.js', 'TypeScript', 'React',
  'Tailwind CSS', 'Next.js', 'Redis', 'Git', 'Docker', 'Prisma', 'PostgreSQL',
  'Postman', 'Linux',
];

const SectionTitle: React.FC<{ title: string; icon: React.ReactNode }> = ({ title, icon }) => (
  <div className="about-section-title">
    <h2>{title}</h2>
    <div className="about-section-icon">{icon}</div>
  </div>
);

const AboutPage: React.FC = () => {
  return (
    <section className="about-page">
      <div className="about-page-inner">
        <nav className="about-breadcrumb" aria-label="مسار التنقل">
          <a href="/">الرئيسية</a>
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true">
            <path d="M5 3L8 6.5L5 10" stroke="#6B7280" strokeWidth="1.08" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <a href="/about">من أنا</a>
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true">
            <path d="M5 3L8 6.5L5 10" stroke="#6B7280" strokeWidth="1.08" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className="about-breadcrumb-current">مهندس برمجيات</span>
        </nav>

        <header className="about-hero">
          <div className="about-hero-left">
            <h1 className="about-hero-name">فيصل القحطاني</h1>
            <div className="about-hero-meta">
              <span className="about-hero-location">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                  <path d="M6 11C6 11 10 7.5 10 4.5C10 2.5 8.21 1 6 1C3.79 1 2 2.5 2 4.5C2 7.5 6 11 6 11Z" stroke="#6B7280" strokeWidth="1" />
                  <circle cx="6" cy="4.5" r="1.5" stroke="#6B7280" strokeWidth="1" />
                </svg>
                <span>الرياض</span>
              </span>
              <span className="about-hero-role">مهندس برمجيات · HudHud Maps</span>
            </div>
          </div>
          <div className="about-hero-avatar">
            <img src="/Image.png" alt="فيصل القحطاني" />
          </div>
        </header>

        <p className="about-bio">
          مهندس برمجيات شغوف ببناء منتجات رقمية تُحدِث فرقاً حقيقياً. أجمع بين الهندسة الخلفية والأمامية لتسليم تجارب مستخدم استثنائية من الفكرة وحتى الإطلاق. أؤمن بأن الكود الجيد يعني الصيانة السهلة والأداء العالي والقابلية للتوسع.
        </p>

        <div className="about-cta">
          <Link to="/#contact" className="about-cta-primary">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <rect x="1.75" y="3" width="10.5" height="8" rx="1.17" stroke="white" strokeWidth="1.17" />
              <path d="M2 4L7 7.5L12 4" stroke="white" strokeWidth="1.17" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>تواصل معي</span>
          </Link>
          <a href="https://www.linkedin.com/in/faisal-turki" target="_blank" rel="noopener noreferrer" className="about-cta-secondary">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <rect x="1.17" y="1.17" width="11.67" height="11.67" rx="1.17" stroke="#111011" strokeWidth="1.17" />
              <circle cx="4" cy="5" r="0.5" fill="#111011" />
              <path d="M4 6.5V10M7 10V8C7 7.45 7.45 7 8 7C8.55 7 9 7.45 9 8V10" stroke="#111011" strokeWidth="1.17" strokeLinecap="round" />
            </svg>
            <span>ملفي على LinkedIn</span>
          </a>
        </div>

        <hr className="about-divider" />

        <section className="about-block">
          <SectionTitle
            title="الخبرات العملية"
            icon={
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <rect x="2" y="4" width="9" height="6.5" rx="0.5" stroke="white" strokeWidth="1.08" />
                <path d="M5 4V3.25C5 2.84 5.34 2.5 5.75 2.5H7.25C7.66 2.5 8 2.84 8 3.25V4" stroke="white" strokeWidth="1.08" />
              </svg>
            }
          />
          <div className="about-timeline">
            {experiences.map((e, i) => (
              <div key={i} className="about-timeline-row">
                <div className="about-timeline-content">
                  <div className="about-timeline-header">
                    <h3>{e.title}</h3>
                    {e.current && <span className="about-current-badge">الآن</span>}
                  </div>
                  <span className="about-company">{e.company}</span>
                  <p className="about-timeline-desc">{e.description}</p>
                </div>
                <span className="about-timeline-date">{e.date}</span>
              </div>
            ))}
          </div>
        </section>

        <hr className="about-divider" />

        <section className="about-block">
          <SectionTitle
            title="التعليم"
            icon={
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M1 4.5L6.5 2L12 4.5L6.5 7L1 4.5Z" stroke="white" strokeWidth="1.08" strokeLinejoin="round" />
                <path d="M3.5 6V9C3.5 9.55 4.84 10 6.5 10C8.16 10 9.5 9.55 9.5 9V6" stroke="white" strokeWidth="1.08" />
              </svg>
            }
          />
          <div className="about-timeline">
            {education.map((e, i) => (
              <div key={i} className="about-timeline-row">
                <div className="about-timeline-content">
                  <div className="about-timeline-header">
                    <h3>{e.degree}</h3>
                    {e.current && <span className="about-current-badge">الآن</span>}
                  </div>
                  <span className="about-company">{e.institution}</span>
                </div>
                <span className="about-timeline-date">{e.date}</span>
              </div>
            ))}
          </div>
        </section>

        <hr className="about-divider" />

        <section className="about-block">
          <SectionTitle
            title="المهارات"
            icon={
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M1.62 6.5L6.5 1.62L11.38 6.5L6.5 11.38L1.62 6.5Z" stroke="white" strokeWidth="1.08" strokeLinejoin="round" />
              </svg>
            }
          />
          <div className="about-pills">
            {skills.map((s) => (
              <span key={s} className="about-pill">{s}</span>
            ))}
          </div>

          <div className="about-tools-label">الأدوات</div>
          <div className="about-pills">
            {tools.map((t) => (
              <span key={t} className="about-pill about-pill-blue">{t}</span>
            ))}
          </div>
        </section>

        <section className="about-cta-block">
          <h2 className="about-cta-block-title"> نشتغل مع بعض؟</h2>
          <p className="about-cta-block-subtitle">تواصل معي وأنا جاهز أبدأ معك من أول فكرة وحتى الإطلاق.</p>
          <Link to="/#contact" className="about-cta-button">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M2 4L7 7.5L12 4" stroke="white" strokeWidth="1.17" strokeLinecap="round" strokeLinejoin="round" />
              <rect x="1.75" y="3" width="10.5" height="8" rx="1.17" stroke="white" strokeWidth="1.17" />
            </svg>
            <span>ابدأ محادثة</span>
          </Link>
        </section>
      </div>
    </section>
  );
};

export default AboutPage;
